'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 271 271",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("defs", null, /*#__PURE__*/React__namespace.createElement("circle", {
    id: "property-sold_svg__a",
    cx: 135.5,
    cy: 135.5,
    r: 135.5
  })), /*#__PURE__*/React__namespace.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__namespace.createElement("mask", {
    id: "property-sold_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React__namespace.createElement("use", {
    xlinkHref: "#property-sold_svg__a"
  })), /*#__PURE__*/React__namespace.createElement("use", {
    fill: "#B4CBEB",
    xlinkHref: "#property-sold_svg__a"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M196 207.43 19.267 284.204c-5.983 1.75-11.005.613-15.03-3.41-4.05-4.036-5.201-9.03-3.434-14.995L77.823 87 196 207.43Z",
    fill: "#F7B731",
    mask: "url(#property-sold_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M4.472 281c-4.218-4.206-5.46-9.472-3.692-15.787l6.332-14.214 1.577-2.098A4124.038 4124.038 0 0 1 102.11 111L138 147.84c-16.189 11.939-39.505 33.338-69.925 64.21C37.633 242.931 16.432 265.904 4.472 281",
    fill: "#FED330",
    mask: "url(#property-sold_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M156.835 126.917c16.591 16.825 28.681 32.612 36.27 47.34 7.589 14.718 8.913 24.897 3.974 30.494-6.006 5.263-16.412 4.137-31.241-3.412-14.83-7.537-30.635-19.634-47.395-36.29-16.771-16.647-28.951-32.345-36.54-47.074-7.6-14.728-8.924-25.063-3.974-31.028 5.995-4.906 16.423-3.69 31.241 3.679 14.83 7.359 30.725 19.456 47.665 36.291",
    fill: "#9F6C33",
    mask: "url(#property-sold_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M77.946 192c-.384 3.768-2.46 5.664-6.228 5.664s-5.664-1.896-5.664-5.664 1.896-5.664 5.664-5.664 5.844 1.896 6.228 5.664",
    fill: "#F4F2AB",
    mask: "url(#property-sold_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M183.835 61.057c-1.062 5.283-3.877 9.155-8.436 11.618-3.52 2.104-7.207 3.167-11.073 3.167l-3.687-.537c-3.162-.336-5.799 0-7.9 1.063-1.05.705-1.765 1.936-2.111 3.694-.358 1.768 0 3 1.061 3.693 1.743 1.768 4.023 3 6.838 3.694 5.978 1.063 10.716 3.436 14.235 7.14 3.509 3.694 4.916 8.003 4.224 12.928-.715 4.935-3.52 8.797-8.436 11.617-3.52 1.769-7.207 2.642-11.073 2.642h-3.687c-2.816-.705-5.453-.347-7.9 1.052-1.061.358-1.854 1.421-2.38 3.167-.525 1.769 0 3.358 1.587 4.757 1.575 1.41 3.944 2.462 7.106 3.168 3.173.705 4.57 2.64 4.224 5.808-.358 3.168-2.112 4.925-5.274 5.272l-1.05-.526c-5.632-.694-10.202-2.977-13.71-6.861-3.52-3.873-4.927-8.26-4.212-13.196.692-4.925 3.43-8.719 8.167-11.36 4.749-2.63 9.755-3.604 15.028-2.899 2.805.705 5.263.347 7.375-1.063 1.397-.336 2.28-1.31 2.637-2.9.346-1.577-.179-3.167-1.576-4.756-1.419-1.578-3.52-2.54-6.335-2.899h-.525c-5.263-1.052-9.754-3.436-13.442-7.13-3.687-3.693-5.184-8.091-4.48-13.195.704-5.093 3.34-8.887 7.91-11.35 4.56-2.462 9.654-3.346 15.286-2.64 2.804.346 5.274 0 7.374-1.064 1.408-.694 2.28-1.925 2.637-3.694.346-1.757 0-2.988-1.05-3.693-1.766-1.757-4.224-2.988-7.375-3.694-3.173-.705-4.491-2.72-3.955-6.077.525-3.335 2.369-5.003 5.53-5.003 5.62 1.052 10.28 3.425 13.967 7.118 3.688 3.694 5.174 8.014 4.48 12.939",
    fill: "#19DC9B",
    mask: "url(#property-sold_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M206.254 92c-3.174 0-5.732 1.068-7.672 3.18-1.94 2.125-2.905 4.687-2.905 7.688 0 3.012.964 5.564 2.905 7.688 1.94 2.124 4.498 3.18 7.672 3.18 3.174 0 5.732-1.056 7.672-3.18 1.94-2.124 2.917-4.676 2.917-7.688 0-3-.976-5.563-2.917-7.687-1.94-2.113-4.498-3.181-7.672-3.181m41.278 90.138c2.456 0 4.408-1.068 5.821-3.18 1.402-3.89.527-6.89-2.647-9.014l-4.767-2.653c-7.762-5.653-19.046-9.98-33.863-12.992-14.818-3.001-31.744 2.562-50.801 16.701-3.163 2.484-3.432 5.305-.785 8.486 2.647 3.18 5.552 3.708 8.726 1.584 15.524-11.655 29.276-16.252 41.267-13.779 11.99 2.473 21.704 6.361 29.107 11.666l5.294 2.653c.696.348 1.582.528 2.648.528M109.42 228.792c-3.174 0-5.732.978-7.661 2.91-1.952 1.956-2.917 4.519-2.917 7.688 0 3.18.965 5.755 2.917 7.688 1.93 1.955 4.487 2.922 7.66 2.922 3.175 0 5.733-.967 7.673-2.922 1.94-1.933 2.916-4.507 2.916-7.688 0-3.17-.975-5.732-2.916-7.687-1.94-1.933-4.498-2.911-7.672-2.911M38.519 103.138c0 2.473-.886 4.597-2.636 6.361-1.772 1.776-3.97 2.653-6.618 2.653-2.647 0-4.857-.877-6.618-2.653-1.772-1.764-2.647-3.978-2.647-6.63 0-2.653.875-4.856 2.647-6.632 1.761-1.753 3.97-2.641 6.618-2.641 2.647 0 4.846.888 6.618 2.641 1.75 1.776 2.636 4.069 2.636 6.901",
    fill: "#F46364",
    mask: "url(#property-sold_svg__b)"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M259.603 126.362c-1.606-1.582-3.55-2.362-5.869-2.362-2.318 0-4.263.78-5.868 2.362-1.595 1.581-2.397 3.509-2.397 5.781 0 2.284.802 4.2 2.397 5.782 1.605 1.582 3.55 2.361 5.868 2.361 2.318 0 4.263-.78 5.869-2.361 1.605-1.582 2.397-3.587 2.397-6.038 0-2.105-.792-3.944-2.397-5.525m-47.469 117.713c1.595 1.571 2.397 3.51 2.397 5.782 0 2.272-.802 4.2-2.397 5.77-1.605 1.582-3.562 2.373-5.868 2.373-2.318 0-4.274-.79-5.869-2.373-1.605-1.57-2.397-3.498-2.397-5.77 0-2.273.792-4.211 2.397-5.782 1.595-1.582 3.641-2.372 6.129-2.372 2.137 0 4.003.79 5.608 2.372",
    fill: "#F7B731"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M220.159 46.662c-3.51 0-5.277 1.76-5.277 5.257s1.767 5.246 5.277 5.246c3.51 0 5.444-1.749 5.802-5.246-.358-3.497-2.292-5.257-5.802-5.257m-114.967 56.21c-1.051 0-1.934-.166-2.639-.523-3.163-2.093-4.035-4.9-2.627-8.397l2.102-4.21a190.633 190.633 0 0 0 6.07-12.084c1.923-4.2 2.896-8.576 2.896-13.132.704-10.859-5.266-21.016-17.932-30.472-2.817-2.45-3.074-5.168-.782-8.141 2.28-2.974 5.008-3.42 8.172-1.315 15.818 11.561 23.543 24.87 23.208 39.928-.358 6.304-1.677 12.085-3.958 17.342-2.291 5.245-4.482 9.8-6.595 13.654-1.051 1.403-1.767 2.807-2.113 4.199-1.409 2.105-3.343 3.152-5.802 3.152m-79.63-72.238c0 3.33-1.755 4.99-5.265 4.99-3.522 0-5.277-1.66-5.277-4.99 0-3.319 1.755-5.157 5.277-5.513 3.51.356 5.265 2.194 5.265 5.513",
    fill: "#1098F3"
  })));
});
var PropertySold = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.PropertySold = PropertySold;